import React from "react";
import { MapPin } from "lucide-react";
import BreadcrumbNav from "@/components/BreadcrumbNav";

export default function CityHero({ cityName, headline, introCopy, breadcrumbs }) {
  return (
    <section className="bg-br-black text-white">
      <div className="container-br py-12 lg:py-16">
        <BreadcrumbNav dark items={breadcrumbs} />
        <div className="max-w-3xl mt-5">
          <div className="br-eyebrow text-br-bronze-2">
            <MapPin size={12} className="inline mr-1" />{cityName}, TX
          </div>
          <h1 className="br-headline text-4xl sm:text-5xl mt-3">{headline}</h1>
          <p className="mt-4 text-gray-300 leading-relaxed">{introCopy}</p>
        </div>
      </div>
    </section>
  );
}
